<template>
  <header class="bg-white fixed w-full shadow-sm border-b">
    <div class="container mx-auto">
      <nav>
        <ul class="flex">
          <li
            class="hover:bg-gray-100"
            v-for="(item, i) in navbar"
            :key="i"
          >
            <router-link
              :to="{name: item.routeName}"
              class="p-4 block flex justify-center items-center gap-3 whitespace-nowrap"
              exact-active-class="text-easyGreen border-b-2 border-easyGreen"
            >
              <i
                class="text-2xl"
                :class="`zmdi zmdi-${item.icon}`"
              ></i>
              {{ item.title }}
              <i class="zmdi zmdi-unfold-more text-gray-400" v-show="item.dropdown"></i>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'NavBar',
  data () {
    return {
      navbar: [{
        id: 1,
        title: 'Calendar',
        icon: 'calendar',
        dropdown: true,
        routeName: 'Calendar'
      }, {
        id: 2,
        title: 'Clients',
        icon: 'accounts',
        dropdown: true,
        routeName: 'Clients'
      }, {
        id: 3,
        title: 'Services',
        icon: 'assignment-check',
        dropdown: false,
        routeName: 'Services'
      }, {
        id: 4,
        title: 'Invoices',
        icon: 'file-text',
        dropdown: true,
        routeName: 'Invoices'
      }, {
        id: 5,
        title: 'Gift cards',
        icon: 'card-giftcard',
        dropdown: false,
        routeName: 'Gift cards'
      }, {
        id: 6,
        title: 'Online courses',
        icon: 'graduation-cap',
        dropdown: false,
        routeName: 'Online courses'
      }, {
        id: 7,
        title: 'Statistics',
        icon: 'chart',
        dropdown: false,
        routeName: 'Statistics'
      }, {
        id: 8,
        title: 'EasyPay',
        icon: 'card',
        dropdown: false,
        routeName: 'EasyPay'
      }, {
        id: 9,
        title: 'Settings',
        icon: 'settings',
        dropdown: false,
        routeName: 'Settings'
      }, {
        id: 10,
        title: 'Apps',
        icon: 'apps',
        dropdown: false,
        routeName: 'Apps'
      }]
    }
  }
}
</script>
